import gql from 'graphql-tag';
import client from '../../client';
import { INVENTORY_FIELDS } from '../fragments/inventoryFields';
import { ORDER_FIELDS } from '../fragments/ordersFields';
import { PRODUCT_FIELDS } from '../fragments/productFields';
export const CREATE_ORDER = gql `
  ${ORDER_FIELDS}
  ${INVENTORY_FIELDS}
  ${PRODUCT_FIELDS}

  mutation CreateOrder($input: OrderInput!) {
    createOrder(input: $input) @rest(type: "OrderResponse", path: "admin/orders/create", method: "POST") {
      data @type(name: "OrderWithPaymentIntent") {
        order {
          ...OrderFields
          products @type(name: "Product") {
            ...ProductFields
            inventory @type(name: "Inventory") {
              ...InventoryFields
            }
          }
          extras {
            next {
              membershipId
            }
          }
          createdAt
          updatedAt
        }
        paymentIntent {
          id
          client_secret
        }
      }
    }
  }
`;
export const createOrder = (membershipId, userId, productId, inventoryId, card) => {
    const variables = {
        input: {
            userId,
            data: Object.assign(Object.assign({ type: membershipId ? 'hdcMembershipUpgrade' : 'hdcMembershipCreation' }, (membershipId && { membershipId })), { products: [
                    {
                        id: productId,
                        quantity: 1,
                        inventory: {
                            id: inventoryId,
                        },
                    },
                ] }),
        },
    };
    if (card.provider === 'MONEYPLATFORM') {
        variables.input.data = Object.assign(Object.assign({}, variables.input.data), { token: card === null || card === void 0 ? void 0 : card.token, externalId: card.externalId, fingerprint: card === null || card === void 0 ? void 0 : card.fingerprint, paymentProvider: 'MONEYPLATFORM', processMoneyPlatformPayment: true });
    }
    else {
        variables.input.data = Object.assign(Object.assign({}, variables.input.data), { paymentType: 'autopay' });
    }
    return client.mutate({
        mutation: CREATE_ORDER,
        variables,
    });
};
export default createOrder;
